import html2pdf from "html2pdf.js";

type Html2PdfOptions = {
  margin?: number | [number, number] | [number, number, number, number];
  filename?: string;
  image?: { type?: "jpeg" | "png" | "webp"; quality?: number };
  html2canvas?: any;
  jsPDF?: {
    unit?: string;
    format?: string | [number, number];
    orientation?: "portrait" | "landscape";
  };
  pagebreak?: {
    mode?: Array<"avoid-all" | "css" | "legacy">;
    before?: string | string[];
    after?: string | string[];
    avoid?: string | string[];
  };
};

export const exportToPDF = (elementId: string, filename: string) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  element.classList.add("pdf-export");

  // Use the element width as the PDF page width
  const contentWidth = Math.ceil(element.getBoundingClientRect().width);

  // Landscape A-series ratio: height = width / sqrt(2)
  const pageHeight = Math.round(contentWidth / Math.SQRT2);

  const opt: Html2PdfOptions = {
    margin: 0,
    filename: `${filename}.pdf`,
    image: { type: "jpeg", quality: 0.95 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
      logging: false,
      scrollX: 0,
      scrollY: 0,
      windowWidth: contentWidth,
    },
    jsPDF: {
      unit: "px",
      format: [contentWidth, pageHeight], // page width == element width
      orientation: "landscape",
    },
    pagebreak: {
      mode: ["css", "legacy"],
      avoid: ["tr"],
    },
  };

  return html2pdf()
    .set(opt)
    .from(element)
    .save()
    .finally(() => {
      element.classList.remove("pdf-export");
    });
};
